export default __webpack_public_path__ + "static/media/renoi.5a8dd0f6.jpg";